// Entrega por bairro: o que conta como bairro cadastrado e quando a entrega fica
// sem saída. A mesma régua vale na vitrine (Checkout), no painel (Configurações)
// e no alerta da Atendente.

export interface LojaEntregaPorBairro {
  deliveryFeeType?: string | null;
  deliveryNeighborhoods?: unknown;
  acceptUnlistedNeighborhoods?: boolean | null;
}

/** Bairros da lista que o cliente consegue escolher. */
export function bairrosComNome(lista: unknown): Array<{ name: string }> {
  if (!Array.isArray(lista)) return [];
  // "Adicionar bairro" no painel cria {name: ""}: sem nome, o cliente não tem o que escolher.
  return lista.filter(
    (b): b is { name: string } => !!b && typeof b === "object" && String((b as { name?: unknown }).name ?? "").trim() !== "",
  );
}

/**
 * Por bairro, sem nenhum bairro escolhível e sem aceitar bairro não cadastrado:
 * o seletor da taxa não tem opção e o pedido de entrega trava no "Falta
 * preencher: Bairro".
 */
export function entregaPorBairroSemSaida(loja: LojaEntregaPorBairro): boolean {
  return (
    loja.deliveryFeeType === "neighborhood" &&
    !loja.acceptUnlistedNeighborhoods &&
    bairrosComNome(loja.deliveryNeighborhoods).length === 0
  );
}

/** Modo em que o checkout abre. */
export function modoDeEntregaInicial(
  loja: LojaEntregaPorBairro & { allowsDelivery?: boolean | null; allowsPickup?: boolean | null },
): "entrega" | "retirada" | null {
  // Entrega sem saída abre em Retirada; só entrega fica nela (a vitrine explica).
  if (loja.allowsDelivery && !(loja.allowsPickup && entregaPorBairroSemSaida(loja))) return "entrega";
  if (loja.allowsPickup) return "retirada";
  return null;
}

/** Valor do seletor para «Outro bairro» (o cliente digita o nome). */
export const OUTRO_BAIRRO = "__other__";

/**
 * Bairro da taxa escolhido: um nome da lista, ou «Outro bairro» com o nome
 * digitado. Em branco o servidor recusa o pedido ("Bairro obrigatório").
 */
export function bairroDaTaxaEscolhido(selecionado: string, textoDigitado: string, nomesDaLista: string[]): boolean {
  if (selecionado === OUTRO_BAIRRO) return textoDigitado.trim() !== "";
  // Endereço salvo traz o bairro como o cliente escreveu ("Ipitanga" × "IPITANGA"):
  // vale a mesma igualdade da taxa e do servidor.
  const alvo = normalizarBairro(selecionado);
  return alvo !== "" && nomesDaLista.some((n) => normalizarBairro(n) === alvo);
}

/** Igualdade de bairro da taxa: sem acento, minúsculas, sem espaço nas pontas (igual ao servidor). */
export function normalizarBairro(s: string): string {
  return (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
}
